export const Jamnagar = {
    title: "Jamnagar",
    title1: "(Brass)",
    attractions: [
        {
            name: "Lakhota Palace",
            description: "A historic palace located in the middle of Ranmal Lake, Lakhota Palace is now a museum showcasing artifacts, weapons, and sculptures from the past. The palace offers a glimpse into the royal heritage of Jamnagar and provides stunning views of the lake.",
            location: "Ranmal Lake, Jamnagar",
            timings: "9:00 AM to 6:00 PM",
            ticket: "₹20 for Indians, ₹100 for Foreigners",
            bestTimeToVisit: "Evening for a scenic view",
            activities: [
                "Explore the museum exhibits",
                "Enjoy the serene views of Ranmal Lake",
                "Take a boat ride in the lake",
                "Photography of the palace and surroundings",
                "Learn about the history of Jamnagar"
            ],
            mapLink: "https://maps.app.goo.gl/example1",
        },
        {
            name: "Marine National Park",
            description: "The first marine national park in India, this park is home to a diverse range of marine life, including corals, dolphins, and exotic fish. It is a paradise for nature lovers and offers opportunities for snorkeling and scuba diving.",
            location: "Gulf of Kutch, Near Jamnagar",
            timings: "8:00 AM to 6:00 PM",
            ticket: "₹50 for Indians, ₹200 for Foreigners",
            bestTimeToVisit: "November to February",
            activities: [
                "Snorkeling and scuba diving",
                "Explore coral reefs",
                "Bird watching",
                "Boat rides to Pirotan Island",
                "Photography of marine life"
            ],
            mapLink: "https://maps.app.goo.gl/example2",
        },
        {
            name: "Bala Hanuman Temple",
            description: "Famous for its non-stop chanting of the 'Ram Dhun' since 1964, this temple holds a place in the Guinness Book of World Records. It is a spiritual hub for devotees and a symbol of devotion and peace.",
            location: "Near Ranmal Lake, Jamnagar",
            timings: "5:00 AM to 10:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Participate in the Ram Dhun chanting",
                "Attend evening aarti",
                "Meditate in the peaceful environment",
                "Explore the temple architecture",
                "Visit nearby Ranmal Lake"
            ],
            mapLink: "https://maps.app.goo.gl/example3",
        },
        {
            name: "Khijadiya Bird Sanctuary",
            description: "A haven for bird watchers, this sanctuary is home to over 300 species of migratory and resident birds. It is located near the Marine National Park and offers a tranquil environment for nature enthusiasts.",
            location: "Near Marine National Park, Jamnagar",
            timings: "6:00 AM to 6:00 PM",
            ticket: "₹50 for Indians, ₹200 for Foreigners",
            bestTimeToVisit: "November to March",
            activities: [
                "Bird watching",
                "Nature walks",
                "Photography of birds and landscapes",
                "Explore the wetland ecosystem",
                "Visit nearby Marine National Park"
            ],
            mapLink: "https://maps.app.goo.gl/example4",
        },
        {
            name: "Darbargadh Palace",
            description: "A stunning example of Rajput and European architecture, Darbargadh Palace was the residence of the royal family of Jamnagar. Though partially in ruins, it still reflects the grandeur of the past.",
            location: "Darbargadh, Jamnagar",
            timings: "10:00 AM to 5:00 PM",
            ticket: "₹50 for Indians, ₹100 for Foreigners",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Explore the palace architecture",
                "Photography of the ruins",
                "Learn about the history of the royal family",
                "Visit nearby temples and markets",
                "Enjoy the serene atmosphere"
            ],
            mapLink: "https://maps.app.goo.gl/example5",
        },
        {
            name: "Pirotan Island",
            description: "A part of the Marine National Park, Pirotan Island is known for its pristine beaches, coral reefs, and diverse marine life. It is a perfect destination for adventure seekers and nature lovers.",
            location: "Gulf of Kutch, Near Jamnagar",
            timings: "Daylight hours",
            ticket: "Permission required from Forest Department",
            bestTimeToVisit: "November to February",
            activities: [
                "Snorkeling and scuba diving",
                "Explore coral reefs",
                "Bird watching",
                "Photography of marine life",
                "Relax on the beach"
            ],
            mapLink: "https://maps.app.goo.gl/example6",
        },
        {
            name: "Solarium",
            description: "Built by Maharaja Kumar Ranjitsinhji, Solarium is a unique structure designed to receive maximum sunlight. It is an architectural marvel and a lesser-known gem in Jamnagar.",
            location: "Near Ranmal Lake, Jamnagar",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning",
            activities: [
                "Explore the unique architecture",
                "Photography",
                "Learn about its history",
                "Visit nearby Ranmal Lake",
                "Enjoy the peaceful surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/example7",
        },
        {
            name: "Willingdon Crescent",
            description: "A beautiful colonial-era market circle, Willingdon Crescent is known for its European-style architecture and vibrant shopping experience. It is a great place to explore local culture and shop for souvenirs.",
            location: "City Center, Jamnagar",
            timings: "10:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Shopping for local handicrafts",
                "Explore colonial architecture",
                "Try local street food",
                "Photography",
                "Experience the local culture"
            ],
            mapLink: "https://maps.app.goo.gl/example8",
        },
        {
            name: "Ranjitsagar Dam",
            description: "Also known as Shetrunji Dam, this is one of the largest dams in Gujarat. It is a popular spot for picnics and offers scenic views of the surrounding landscape.",
            location: "Near Jamnagar",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Monsoon or Winter",
            activities: [
                "Picnic with family and friends",
                "Photography of the dam and surroundings",
                "Enjoy the scenic views",
                "Explore nearby villages",
                "Relax in the peaceful environment"
            ],
            mapLink: "https://maps.app.goo.gl/example9",
        },
        {
            name: "Jama Masjid",
            description: "A beautiful mosque built during the reign of Jam Rawal, Jama Masjid is known for its intricate architecture and peaceful ambiance. It is a significant religious site in Jamnagar.",
            location: "City Center, Jamnagar",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Explore the mosque architecture",
                "Attend prayers",
                "Photography",
                "Learn about its history",
                "Visit nearby markets"
            ],
            mapLink: "https://maps.app.goo.gl/example10",
        },
        {
            name: "Bhujio Kotho",
            description: "A historic watchtower built during the reign of Jam Rawal, Bhujio Kotho offers panoramic views of Jamnagar. It is a lesser-known but fascinating historical site.",
            location: "Near Ranmal Lake, Jamnagar",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Climb the watchtower for views",
                "Photography",
                "Learn about its history",
                "Visit nearby Ranmal Lake",
                "Explore the surrounding area"
            ],
            mapLink: "https://maps.app.goo.gl/example11",
        },
        {
            name: "Rozi Port",
            description: "A major port in Gujarat, Rozi Port is known for its scenic beauty and bustling activity. It is a great place to witness the local fishing industry and enjoy the sea breeze.",
            location: "Near Jamnagar",
            timings: "Daylight hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Watch fishing activities",
                "Enjoy the sea breeze",
                "Photography",
                "Explore nearby beaches",
                "Relax by the port"
            ],
            mapLink: "https://maps.app.goo.gl/example12",
        },
        {
            name: "Kotha Bastion",
            description: "A historic fortification built during the reign of Jam Rawal, Kotha Bastion is a symbol of Jamnagar's rich history. It offers a glimpse into the city's past and its strategic importance.",
            location: "City Center, Jamnagar",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Explore the fortification",
                "Photography",
                "Learn about its history",
                "Visit nearby markets",
                "Enjoy the peaceful surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/example13",
        },
        {
            name: "Vijay Vilas Palace",
            description: "A beautiful palace built by Maharaja Vijay Singhji, Vijay Vilas Palace is known for its stunning architecture and lush gardens. It is a popular spot for photography and relaxation.",
            location: "Near Jamnagar",
            timings: "10:00 AM to 6:00 PM",
            ticket: "₹50 for Indians, ₹100 for Foreigners",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Explore the palace architecture",
                "Photography",
                "Stroll through the gardens",
                "Learn about its history",
                "Relax in the peaceful environment"
            ],
            mapLink: "https://maps.app.goo.gl/example14",
        },
        {
            name: "Gopi Talav",
            description: "A historic lake built by Maharaja Kumar Ranjitsinhji, Gopi Talav is known for its beautiful surroundings and peaceful ambiance. It is a great place for a leisurely walk or picnic.",
            location: "Near Ranmal Lake, Jamnagar",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Leisurely walk around the lake",
                "Picnic with family and friends",
                "Photography",
                "Enjoy the peaceful surroundings",
                "Visit nearby Ranmal Lake"
            ],
            mapLink: "https://maps.app.goo.gl/example15",
        },
    ]
};